import React from "react";

const noCodeLogo = () => {
  return (
    <>
      <section className="nocode services box lficon position-re industry">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 wow fadeInLeft">
              <div className="industry item-box no-curve">
                <div className="cont">
                  <h6>Resturants</h6>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div className="cont">
                  <h6>Real Estate</h6>
                </div>
              </div>

              <div className="industry item-box no-curve">
                <div className="cont">
                  <h6>E-Commerce</h6>
                </div>
              </div>

              <div className="industry item-box no-curve">
           
                <div className="cont">
                  <h6>Education</h6>
                </div>
              </div>
              <div className="industry item-box no-curve">
                <div className="cont">
                  <h6>SaaS</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default noCodeLogo;
